module.exports = __webpack_public_path__ + "img/Map-Folder.c8f4aab4.png";